import type { IconData } from '@stacksjs/iconify-core'

export const userMinus: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.534 10.07a1 1 0 1 1 .733 1.86A3.58 3.58 0 0 0 2 15.26V17a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.647a3.66 3.66 0 0 0-2.356-3.419a1 1 0 1 1 .712-1.868A5.66 5.66 0 0 1 14 15.353V17a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-1.74a5.58 5.58 0 0 1 3.534-5.19M7 0a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2m6 3h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default userMinus
